module.exports = __webpack_public_path__ + "img/usine.b6de8bc2.png";